SelectMemberView = require 'views/member/select-member-view'

module.exports = class SelectMemberOnCardView extends SelectMemberView
  #extra option: card
  initialize: ->
    @listenTo @options.card, 'change:idMembers', @renderActive

  renderActive: ->
    @$('.js-member-item').toggleClass('active', @model.id in @options.card.get('idMembers'))

  render: ->
    super
    @renderActive()

    @



// WEBPACK FOOTER //
// ./app/scripts/views/member/select-member-on-card-view.coffee